import { z } from 'zod'
import { BUSINESS_DEFAULT_TAG_COLOR, businessColorSchema } from '../business/contract.ts'
import { createdAtSortQueryShape, creatorListQueryShape } from '../list-query/contract.ts'
import { accountDisplaySchema } from '../profile/contract.ts'

const id = z.number().int().positive()
const ids = z.array(id).min(1).max(100)
export const expenseBusinessListSchema = z.object({
  current: id.default(1),
  pageSize: id.max(100).default(20),
  id: id.optional(),
  keyword: z.string().trim().max(255).optional(),
  status: z.enum(['enabled', 'disabled']).optional(),
  ...creatorListQueryShape,
  ...createdAtSortQueryShape
})
export const expenseBusinessUpsertSchema = z.object({
  name: z.string().trim().min(1, '请输入支出业务名称').max(255),
  color: businessColorSchema.default(BUSINESS_DEFAULT_TAG_COLOR),
  note: z.string().trim().max(5000).nullish()
})
export const expenseBusinessUpsertRequestSchema = z.object({ id: id.optional(), data: expenseBusinessUpsertSchema })
export const expenseBusinessRemoveSchema = z.object({ id })
export const expenseBusinessSetEnabledSchema = z.object({ id, isEnabled: z.boolean() })
export const expenseBusinessBatchSetEnabledSchema = z.object({ ids, isEnabled: z.boolean() })
export const expenseBusinessBatchRemoveSchema = z.object({ ids })
export const expenseBusinessBatchOperationResultSchema = z.object({ count: z.number() })
export const expenseBusinessSchema = expenseBusinessUpsertSchema.extend({
  id,
  note: z.string().nullable(),
  isEnabled: z.boolean(),
  creator: accountDisplaySchema,
  createdAt: z.date(),
  updatedAt: z.date()
})
export const expenseBusinessListOutputSchema = z.object({
  data: z.array(expenseBusinessSchema.extend({ billCount: z.number() })),
  total: z.number(),
  current: id,
  pageSize: id
})
export const expenseBusinessOptionsInputSchema = z.object({ keyword: z.string().trim().max(255).optional() })
export const expenseBusinessOptionSchema = z.object({ value: id, label: z.string(), color: businessColorSchema })
export const expenseBusinessBatchCreateSchema = z.object({ names: z.array(z.string().trim()).min(1).max(100) })
export const expenseBusinessBatchCreateResultSchema = z.object({
  successCount: z.number(),
  failureCount: z.number(),
  failures: z.array(z.object({ name: z.string(), reason: z.string() }))
})
export type ExpenseBusinessListInput = z.infer<typeof expenseBusinessListSchema>
export type ExpenseBusinessOptionsInput = z.infer<typeof expenseBusinessOptionsInputSchema>
export type ExpenseBusinessUpsertInput = z.infer<typeof expenseBusinessUpsertSchema>
export type ExpenseBusinessRemoveInput = z.infer<typeof expenseBusinessRemoveSchema>
export type ExpenseBusinessBatchRemoveInput = z.infer<typeof expenseBusinessBatchRemoveSchema>
export type ExpenseBusinessBatchSetEnabledInput = z.infer<typeof expenseBusinessBatchSetEnabledSchema>
export type ExpenseBusinessBatchCreateInput = z.infer<typeof expenseBusinessBatchCreateSchema>
export type ExpenseBusinessBatchCreateResult = z.infer<typeof expenseBusinessBatchCreateResultSchema>
